import Swal from "sweetalert2";

import { clearMemory, clearMemoryCashOutDetail, notProcessRequest, processRequest, setCashOutDetail, setData, setDataCashOutList, setError } from "./slice";
import { URL_API } from "../../../../../app/apiConnection";


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


export const clearStoreCashOutDetail = () => {
    return (dispatch, getState) => {
        dispatch(clearMemoryCashOutDetail());
    }
}



export const getIncomeList = (dateBegin, dateEnd) => {
    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());
        await URL_API.get(`CashOut/getIncomeList/${dateBegin}/${dateEnd}`).then(function (response) {
            console.log(response.data);
            if (response.data.status == 200) {
                dispatch(setData({
                    msg: response.data.msg,
                    dateStart: response.data.fInicio,
                    dateEnd: response.data.fFinal,
                    orders_totals: response.data.ordenes.totales,
                    sales_totals: response.data.ventas.totales,
                    advancedPayment_totals: response.data.anticipos.totales,
                    orders_details: response.data.ordenes.detalles,
                    sales_details: response.data.ventas.detalles,
                    advancedPayment_details: response.data.anticipos.detalles,
                    discounts_totals: response.data.descuentos.totales,
                    discounts: response.data.descuentos.detalles,
                }))
            }
            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            console.log(error.response.data);


            dispatch(setError({
                msg: error.response.data.msg

            }))
        });
    }
}

export const getCashOutList = (dateBegin, dateEnd, word) => {

    // Lanzar petidion de acuerdo al param word

    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());

        await URL_API.get(`CashOut/getCashOutList/${dateBegin}/${dateEnd}/${word}`).then(function (response) {
            // console.log(response.data);
            // console.log(response.data.rows);

            if (response.data.status == 200) {
                dispatch(setDataCashOutList({
                    msg: response.data.msg,
                    list_cashOut: response.data.rows,
                }))
            }
            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            // console.log(error.response.data);
            dispatch(setError({
                msg: error.response.data.msg
            }))
        });
    }
}

export const getCashOutDetailByID = (id) => {
    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());
        await URL_API.get(`CashOut/getCashOutDetail/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                dispatch(setCashOutDetail({
                    msg: response.data.msg,
                    cashOut_detail: response.data,
                }))
            }
            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            console.log(error.response.data);


            dispatch(setError({
                msg: error.response.data.msg

            }))
        });
    }
}

export const postCashOut = (userName, branch, cashBase, expectedTotal, realTotal, difference, cashOutDetails, ordersDetails, salesDetails, advancedPaymentDetails, discounts,dateStart, dateEnd) => {

    return async (dispatch, getState) => {
        dispatch(processRequest());

        let dat = new Date();
        let d = dat.getDate();
        let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
        let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d
        let fechahora = new Date(); let hora = fechahora.getHours(); let minuto = fechahora.getMinutes(); let segundo = fechahora.getSeconds();
        if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;
        let horaRegistro = `${hora}:${minuto}:${segundo}`;

        await URL_API.post(`CashOut/postCashOut`, {
            userName: userName,
            branch: branch,
            cashBase: cashBase,
            expectedTotal: expectedTotal,
            realTotal: realTotal,
            difference: difference,
            dateRegister: fechaRegistro,
            hourRegister: horaRegistro,
            dateStart: dateStart,
            dateEnd: dateEnd,
            hourStart: '9:00:00',
            hourEnd: horaRegistro,
            cashOutDetails: cashOutDetails,
            orders: ordersDetails,
            sales: salesDetails,
            advancedPayments: advancedPaymentDetails,
            discounts:discounts

        }).then(function (response) {

            // console.log(response.data);
            if (response.data.status = 200) {

                Swal.fire({
                    icon: 'success',
                    title: 'Atencion',
                    text: `Corte registrado correctamente, ID:${response.data.id}`,
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        // console.log('Ejecutar Reload...');
                        dispatch(notProcessRequest());
                        dispatch(clearMemory());
                    }
                });

            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro el Corte... Intente de Nuevo'
            })

            return;
        });
        dispatch(notProcessRequest());

    }

}